var _defs, _g, _path, _rect, _rect2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarWithCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #7ea7ac;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #4cb0d3;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-miterlimit: 4;\r\n        stroke-width: 1px;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-miterlimit: 4;\r\n        stroke-width: 1px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.14,39.1H2.34v19c0,1.8,1.4,3.2,3.2,3.2H72.94c1.8,0,3.2-1.4,3.2-3.2v-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2.54,36.1l.2,22.7,2.4,2.2H57.14l-1.6-2,.4-24.6-8.8-.5v21.1l-2.6,.5-32.9,.4-1.5-1.7,.1-19.2s-7.7,1.1-7.7,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.14,40.9H2.34V21.9c0-1.8,1.4-3.2,3.2-3.2H72.94c1.8,0,3.2,1.4,3.2,3.2v19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2.54,43.9l.2-22.7,2.4-2.2H57.14l-1.6,2,.4,24.6-8.8,.5V25l-2.6-.5-32.9-.4-1.5,1.7,.1,19.2s-7.7-1.1-7.7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.73,61.5l-1.7,3.8c-.7,1.5-2.4,2.1-3.9,1.5l-.4-.2,2.4-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.73,18.5l-1.7-3.8c-.7-1.5-2.4-2.1-3.9-1.5l-.4,.2,2.4,5.3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.53,18.9V60.9m0-42l-9.5,5.5m9.5-5.5h-3.5m3.5,0h.5m-.5,42l-9.5-5.83m9.5,5.83h-3.5m3.5,0h.5M3.53,19.9l-1,1V58.9l1,1m0-40l1-1H28.28m-24.75,1l6.5,4.5m0,0v31m0-31H28.28m18.25,31V24.4h-.5m.5,31H28.28m-18.25,0H28.28m-18.25,0l-6.5,4.5M28.28,24.4v-5.5m0,5.5h17.75m-17.75-5.5h23.75M28.28,55.4v5.5m0,0H4.53l-1-1m24.75,1h23.75m3.95-.52l-1.78,6.15-2.46,1.42-2.24-.75,2.31-6.22m4.22-42.08h17l2.5,2v2m-19.5,38h17l2.5-2v-2m0,0v-7m0,0V29.9m0,0v-7m-24.44-3.88l-2.31-6.22,2.24-.75,2.46,1.42,1.78,6.15"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.83,
    y: 25.2,
    width: 0.84,
    height: 5.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.83,
    y: 49.4,
    width: 0.84,
    height: 5.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 28.13,
    y: 26.7,
    width: 0.3,
    height: 24.81,
    transform: "translate(-19.59 32.92) rotate(-46.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.87,
    y: 38.95,
    width: 24.81,
    height: 0.3,
    transform: "translate(-19.1 29.89) rotate(-43.13)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWithCross);
export default __webpack_public_path__ + "static/media/car_with_cross.5583850f8d404bead1484d41df4e79d5.svg";
export { ForwardRef as ReactComponent };